import type { SVGProps } from 'react';

const SvgX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="uuid-a1a74c47-e9aa-4210-9408-c57dc5dc83ab"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color}
      d="M12.89 14.09c-.32 0-.62-.12-.85-.35L7.99 9.69l-4.06 4.06c-.45.45-1.25.45-1.7 0-.22-.22-.35-.53-.35-.85s.12-.62.35-.85L6.29 8 2.25 3.94a1.201 1.201 0 1 1 1.7-1.7L8.01 6.3l4.05-4.06c.45-.45 1.25-.45 1.7 0 .23.22.35.53.35.85s-.12.62-.35.85L9.7 8l4.06 4.05c.22.22.35.53.35.85s-.12.62-.35.85-.52.35-.85.35Z"
    />
  </svg>
);

export default SvgX;
